import { noop } from 'es-toolkit/compat';

class ActivityRecordStore {
  refetch: () => void = noop;
}

export default ActivityRecordStore;
